/* import __COLOCATED_TEMPLATE__ from './fragment-display.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();